import { Alert, Badge } from "react-bootstrap";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
import BadgeEstados from "../BadgeEstado";
import ErrorIcon from '@mui/icons-material/Error';

const HeaderDetalle = () => {

    const { actaDetalle, alertas, alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();

    const { acta, archivos } = actaDetalle;


    const emailsCortesia = acta?.emails_cortesia
        ?.filter((email) => email.estado_id == 3)
        .sort((a, b) => new Date(b.fecha_enviado) - new Date(a.fecha_enviado)) || null;


    return (
        <section className="w-100 ">
            <section className=" d-flex flex-column  align-items-start">
                {
                    (acta.estado_id == 3 || acta.estado_id == 7) && <>
                        {
                            alertas.length > 0 && <><p className=" fs-4 fw-bold text-danger">El acta tiene alertas</p>

                                <div className="d-flex gap-2 px-5 align-items-start">
                                    {
                                        alertasBloqueo.length > 0 &&
                                        <div className="border border-2 border-danger rounded py-2 px-4" style={{ width: "fit-content" }}>
                                            <p className="m-0 fw-bold">Campos necesarios para aprobar el acta</p>
                                            <ul>
                                                {
                                                    alertasBloqueo.map((alerta) => (
                                                        <li className="text-danger fw-medium" key={alerta.id}>{alerta.descripcion}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    }
                                    {
                                        alertasNoBloqueo.length > 0 &&
                                        <div className="border border-2 border-danger rounded py-2 px-4" style={{ width: "fit-content" }}>
                                            <p className="m-0 fw-bold">Campos opcionales para aprobar el acta</p>
                                            <ul>
                                                {
                                                    alertasNoBloqueo.map((alerta) => (
                                                        <li className="text-danger fw-medium" key={alerta.id}>{alerta.descripcion}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </>}
                    </>
                }
                {
                    acta.estado_id == 7 &&
                    <div className="pt-4">
                        <Alert variant="info">
                            <p className="m-0">Al <span className="fw-bold ">COMPLETAR</span> el acta, pasara al estado <span className="fw-bold">APROBADO</span> automaticamente. Verifique los datos antes de completar el acta</p>

                        </Alert>
                    </div>
                }
                {
                    (acta.estado_id == 10 || acta.estado_id == 2 || acta.estado_id == 8 || acta.estado_id == 4 || acta.estado_id == 11 || acta.estado_id == 13 || acta.estado_id == 12 || acta.estado_id == 9 || acta.estado_id == 15) &&
                    <div className="d-flex flex-column">
                        {acta.estado_id == 12 &&
                            <div className="d-flex gap-2">
                                <h5 className="m-0">Motivo anulación: </h5>
                                <h6><Badge bg={`${acta?.motivo?.estado?.nombre ? 'danger' : "primary"}`} size={"lg"}>{acta?.motivo?.estado?.nombre ? acta?.motivo?.estado?.nombre : "No tiene motivo de anulación"}</Badge></h6>
                            </div>
                        }
                        <div className="d-flex gap-2">
                            <h5 className="m-0">Tipo acta generada: </h5>
                            <h6><Badge bg={`${acta?.tipo_acta_generada == "DIGITAL" ? 'success' : "primary"}`} size={"lg"}>{acta?.tipo_acta_generada}</Badge></h6>
                        </div>
                        <hr />

                        {
                            <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Fecha y hora: </h5>
                                    {
                                        acta.fecha_hora ? <p className="m-0 fw-medium">{acta.fecha_hora} </p>
                                            : <p className="m-0 text-danger fw-medium">No tiene fecha hora</p>
                                    }
                                </div>
                            </div>
                        }
                        <hr />
                        {
                            <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Tipo infracción: </h5>
                                    {
                                        acta.tipo ? <p className="m-0 fw-medium">{acta.tipo} </p>
                                            : <p className="m-0 text-danger fw-medium">No tiene tipo</p>
                                    }
                                </div>
                            </div>
                        }
                        <hr />
                        {
                            <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Dirección: </h5>
                                    {
                                        acta.direccion ? <p className="m-0 fw-medium">{acta.direccion} </p>
                                            : <p className="m-0 text-danger fw-medium">No tiene dirección</p>
                                    }
                                </div>
                            </div>
                        }
                        <hr />
                        {
                            (acta.estado_id == 2 || acta.estado_id == 8 || acta.estado_id == 4 || acta.estado_id == 11 || acta.estado_id == 13 || acta.estado_id == 12 || acta.estado_id == 9 || acta.estado_id == 15) &&
                            <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Fecha de impresión: </h5>
                                    {
                                        acta.fecha_impresion ? <p className="m-0 fw-medium">{acta.fecha_impresion.split('T')[0]} - {acta.fecha_impresion.split('T')[1]} </p>
                                            : <p className="m-0 text-danger fw-medium">No fue impresa</p>
                                    }
                                </div>
                            </div>
                        }
                        <hr />
                        {

                            (acta.estado_id == 8 || acta.estado_id == 4 || acta.estado_id == 11 || acta.estado_id == 13 || acta.estado_id == 12 || acta.estado_id == 9 || acta.estado_id == 15) && <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Notificador asignado: </h5>
                                    {
                                        acta.notificador ? <p className="m-0 fw-medium">{acta.notificador.persona.nombre}</p>
                                            : <p className="m-0 text-danger fw-medium">No tiene notificador asigando</p>
                                    }
                                </div>
                                <hr />
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Fecha asignado: </h5>
                                    {
                                        acta.notificador ? <p className="m-0 fw-medium">{acta.notificador.fecha_asignado}</p>
                                            : <p className="m-0 text-danger fw-medium">No tiene fecha de asignado</p>
                                    }
                                </div>
                                <hr />
                            </div>
                        }

                        {

                            (acta.estado_id == 4 || acta.estado_id == 11 || acta.estado_id == 13 || acta.estado_id == 12 || acta.estado_id == 15) && <div>
                                <div className="d-flex gap-2 align-items-center">
                                    <h5 className="m-0">Fecha de notificación: </h5>
                                    {
                                        acta.fecha_notificacion ? <p className="m-0 fw-medium">{acta.fecha_notificacion}</p>
                                            : <p className="m-0 text-danger fw-medium">No tiene fecha de notificación</p>
                                    }
                                </div>
                            </div>
                        }
                        <hr />
                        {

                            (acta.estado_id == 12) &&
                            <>
                                <div>
                                    < div className="d-flex gap-2 align-items-center">
                                        <h5 className="m-0">Es voluntario: </h5>
                                        {acta.is_voluntario ? <Badge bg="success">SI</Badge> : <Badge bg="danger">NO</Badge>}
                                    </div>

                                    <div className="d-flex gap-2 align-items-center">
                                        <h5 className="m-0">Fecha pago: </h5>
                                        {actaDetalle?.recibo?.fecha_pago ? <p className="m-0 fw-medium">{actaDetalle?.recibo?.fecha_pago}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de pago</p>}
                                    </div>
                                </div>
                                <hr />
                            </>
                        }
                    </div>

                }




                {
                    acta.estado_id == 11
                    &&
                    <>
                        <div className="d-flex flex-column">
                            < div className="d-flex gap-2 align-items-center">
                                <h5 className="m-0">Es voluntario: </h5>
                                {acta.is_voluntario ? <Badge bg="success">SI</Badge> : <Badge bg="danger">NO</Badge>}
                            </div>

                            <div className="d-flex gap-2 align-items-center">
                                <h5 className="m-0">Fecha pago: </h5>
                                {actaDetalle?.recibo?.fecha_pago ? <p className="m-0 fw-medium">{actaDetalle?.recibo?.fecha_pago}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de pago</p>}
                            </div>

                        </div>
                        <hr />
                    </>
                }


                {
                    acta.fecha_vto_prejudicial && (acta.estado_id == 4 || acta.estado_id == 15)
                    &&
                    <>
                        <div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Vto. Prejudicial: </h5>
                            {acta.fecha_vto_prejudicial ? <p className="m-0 fw-medium">{acta.fecha_vto_prejudicial}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de vto. prejudicial</p>}
                        </div>
                        <hr />
                    </>
                }

                {
                    acta.estado_id == 9 &&
                    <div className="d-flex flex-column">
                        < div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Motivo: </h5>
                            {acta?.motivo_no_notificado?.motivo ? <p className="m-0 fw-medium">{acta?.motivo_no_notificado?.motivo}</p> : <p className="m-0 text-danger fw-medium">No tiene motivo </p>}
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Observación: </h5>
                            {acta.observacion_notificador ? <p className="m-0 fw-medium">{acta.observacion_notificador}</p> : <p className="m-0 text-danger fw-medium">No tiene observación.</p>}
                        </div>

                    </div>
                }

                {
                    acta.estado_id == 13 &&
                    <div className="d-flex flex-column gap-2">
                        < div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Fecha descargo: </h5>
                            {acta?.fecha_descargo ? <p className="m-0 fw-medium">{acta?.fecha_descargo}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de descargo </p>}
                        </div>
                        <div className=" px-2 pb-3 pt-2 border border-2 border-secondary rounded">
                            <h6 className="m-0">Observación: </h6>
                            <hr className="m-0 mb-1" />
                            {acta.observacion_descargo ? <p className="m-0 fw-medium">{acta.observacion_descargo}</p> : <p className="m-0 text-danger fw-medium">No tiene observación.</p>}
                        </div>

                        {
                            acta.fecha_vto_prejudicial &&
                            <div className="d-flex gap-2 align-items-center">
                                <h5 className="m-0">Vto. Prejudicial: </h5>
                                {acta.fecha_vto_prejudicial ? <p className="m-0 fw-medium">{acta.fecha_vto_prejudicial}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de vto. prejudicial</p>}
                            </div>
                        }

                    </div>
                }
                {
                    (emailsCortesia?.length > 0) &&
                    <div className="d-flex gap-2 align-items-center">
                        <h5 className="m-0">Email de cortesia: </h5>
                        {emailsCortesia[0].fecha_enviado}
                        {/* {acta.fecha_vto_prejudicial ? <p className="m-0 fw-medium">{acta.fecha_vto_prejudicial}</p> : <p className="m-0 text-danger fw-medium">No tiene fecha de vto. prejudicial</p>} */}
                    </div>
                }


            </section>

        </section >
    );
}
export default HeaderDetalle;